import { render, staticRenderFns } from "./PlaylistVideoDetails.vue?vue&type=template&id=a7c1ec28"
import script from "./PlaylistVideoDetails.vue?vue&type=script&lang=js"
export * from "./PlaylistVideoDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports